import React from 'react';
import { BadgeCheck, ChevronRight, Layers, Sparkles, Star } from 'lucide-react';
import PresetLibraryCoverImage from './PresetLibraryCoverImage';
import MarketCoverImage from './MarketCoverImage';
import { t } from '../i18n';

export function learningLanguageLabel(locale) {
  return t(`library.languages.${String(locale || 'en').split('-')[0]}`);
}

export default function LibraryBookCard({ item, onOpen, layout = 'grid' }) {
  const market = item.source === 'market';
  const list = layout === 'list';
  const details = (
    <>
      {!list && <span className={`library-book-author ${market ? 'is-community' : ''}`}>
        {t(market ? 'library.market' : 'library.officialLibrary')}
      </span>}
      <span className="library-book-title-row">
        <strong className="library-book-title" title={item.title}>{item.title}</strong>
        {item.recommended && <span className="library-book-recommended"><Sparkles size={13} aria-hidden="true" />{t(item.selectedRecommendation ? 'library.clickedNote' : 'library.recommended')}</span>}
        {item.installed && <span className="library-book-imported"><BadgeCheck size={14} aria-hidden="true" />{t('library.imported')}</span>}
      </span>
      {list && item.description && <span className="library-book-description">{item.description}</span>}
      <span className="library-book-meta">
        {item.studyKind === 'vocabulary' && <><span>{t('vocabulary.noteType')}</span><span aria-hidden="true"> · </span></>}
        {learningLanguageLabel(item.learningLocale)} · {t('library.level', undefined, { level: item.difficulty })}
        {list && <><span aria-hidden="true"> · </span><span className="library-book-card-count-inline" aria-label={t('library.cardCount', undefined, { count: item.cardCount })}><Layers size={12} aria-hidden="true" />{item.cardCount}</span></>}
      </span>
      {!list && <span className="library-book-topic">{item.topic || t('library.unclassified')}</span>}
      {item.ratingCount > 0 && <span className="library-book-rating">
        <Star size={13} fill="currentColor" aria-hidden="true" />{Number(item.averageRating || 0).toFixed(1)} ({item.ratingCount})
      </span>}
      {item.status && <span className={`library-book-status is-${item.status}`}>{t(`market.status.${item.status}`)}</span>}
    </>
  );
  return (
    <button type="button" className={`library-book${list ? ' is-list' : ''}${item.selectedRecommendation ? ' is-selected-recommendation' : ''}`} onClick={() => onOpen(item)}
      aria-label={t('library.openItem', undefined, { title: item.title })}>
      <span className="library-book-cover">
        {market ? (
          <MarketCoverImage listingId={item.id} hasCover={Boolean(item.coverUrl)} coverVersion={item.coverVersion} alt="" />
        ) : <PresetLibraryCoverImage presetId={item.id} hasCover={Boolean(item.coverUrl)} alt="" />}
        {!list && <span className="library-book-count" aria-label={t('library.cardCount', undefined, { count: item.cardCount })}>
          <Layers size={13} aria-hidden="true" />{item.cardCount}
        </span>}
      </span>
      {list ? <span className="library-book-details">{details}</span> : details}
      {list && <ChevronRight className="library-book-arrow" size={20} aria-hidden="true" />}
    </button>
  );
}
